import { faEllipsis, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import "../../stylesheet/calendar.css";
import { useModal } from "../hooks/useModal";

const modalIdentifier = 'timeSpanSelectorModal';

interface Props {
  handleButtonClick: (
    data: string,
    customStartDate?: string,
    customEndDate?: string,
  ) => void;
  selectedDays: string;
  customStartDate?: string | null;
  customEndDate?: string | null;
}

export const TimeSpanSelector = (props: Props) => {
  const [isCustomDateFilterActive, setIsCustomDateFilterActive] =
    useState(false);

  const [open, setOpen, isOpen] = useModal();

  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  useEffect(() => {
    setCustomStartDate(props.customStartDate ?? "");
    setCustomEndDate(props.customEndDate ?? "");
  }, [props.customStartDate, props.customEndDate]);

  const resetFilter = () => {
    setCustomStartDate("");
    setCustomEndDate("");
    props.handleButtonClick("30d");
    setIsCustomDateFilterActive(false);
    setOpen('');
  };

  return (
    <div className="relative overflow-visible">
      <div className="flex rounded-[4px] text-tqsBlack shadow-lg relative">
        <button
          className={`flex h-[34px] w-[70px] items-center justify-center rounded-l-[4px] border border-gray-200 ${
            props.selectedDays === "30d"
              ? "border-[#f6f6f6] bg-[#f6f6f6] backdrop-blur-md"
              : "bg-white"
          }`}
          onClick={() => {
            props.handleButtonClick("30d");
            setIsCustomDateFilterActive(false);
          }}
        >
          30d
        </button>
        <button
          className={`flex h-[34px] w-[70px] items-center justify-center border border-gray-200 ${
            props.selectedDays === "60d"
              ? "border-[#f6f6f6] bg-[#f6f6f6] backdrop-blur-md"
              : "bg-white"
          }`}
          onClick={() => {
            props.handleButtonClick("60d");
            setIsCustomDateFilterActive(false);
          }}
        >
          60d
        </button>
        <button
          className={`flex h-[34px] w-[70px] items-center justify-center border border-gray-200 ${
            props.selectedDays === "90d"
              ? "border-[#f6f6f6] bg-[#f6f6f6] backdrop-blur-md"
              : "bg-white"
          }`}
          onClick={() => {
            props.handleButtonClick("90d");
            setIsCustomDateFilterActive(false);
          }}
        >
          90d
        </button>
        <button
          className={`flex h-[34px] w-[70px] items-center justify-center rounded-r-[4px] border border-gray-300 ${
            props.selectedDays === "custom"
              ? "border-[#f6f6f6] bg-[#f6f6f6] backdrop-blur-md"
              : "bg-white"
          }`}
          onClick={() => {
            props.handleButtonClick("custom");
            setIsCustomDateFilterActive(false);
            setOpen(modalIdentifier);
          }}
        >
          <FontAwesomeIcon color={'#8E8E93'} icon={faEllipsis} />
        </button>
        {isCustomDateFilterActive && (
          <button
            className="flex items-center rounded-lg bg-tqsLightRed px-3 py-1 text-white"
            onClick={() => {
              props.handleButtonClick("30d");
              setIsCustomDateFilterActive(false);
            }}
          >
            <FontAwesomeIcon icon={faTimes} className="mr-2" />
            Clear Date Range
          </button>
        )}
      </div>

      {isOpen(modalIdentifier) && (
        <div className="absolute z-50 flex items-center justify-center right-[0px] top-[40px]">
          <div className="z-50 rounded-md bg-white p-6 text-tqsBlack shadow-lg">
            {/* <h2 className="mb-4 text-lg font-semibold">
              Enter Custom Date Range
            </h2> */}
            <div className="flex flex-col space-y-2">
              <DayPicker
                mode="range"
                defaultMonth={
                  customStartDate ? new Date(customStartDate ?? "") : undefined
                }
                selected={
                  customStartDate && customEndDate
                    ? {
                        from: new Date(customStartDate ?? ""),
                        to: new Date(customEndDate ?? ""),
                      }
                    : undefined
                }
                onSelect={(selectedRange) => {
                  setCustomStartDate(selectedRange?.from?.toISOString() ?? "");
                  setCustomEndDate(selectedRange?.to?.toISOString() ?? "");
                }}
                className="my-calendar"
              />
            </div>

            <div className="text-md mt-4 flex flex-row font-medium w-[100%]">
              <div className="w-[50%]">
                <span>From: </span>
                <span className="font-bold">
                  {customStartDate
                    ? new Date(customStartDate).toLocaleDateString()
                    : "Select Date"}
                </span>
              </div>
              <div className="w-[50%]">
                <span>To: </span>
                <span className="font-bold">
                  {" "}
                  {customEndDate
                    ? new Date(customEndDate).toLocaleDateString()
                    : "Select Date"}
                </span>
              </div>
            </div>

            <div className="mt-4 flex justify-between space-x-2">
              <div className="flex w-[100%] justify-start">
                <button
                  onClick={() => resetFilter()}
                  className="rounded-md bg-[#212322] px-4 py-2 text-[#ffffff]"
                >
                  Clear Filter
                </button>
              </div>

              <div className="flex justify-end space-x-2">
                <button
                  onClick={() => {
                    setOpen('');
                  }}
                  className="rounded-md bg-gray-300 px-4 py-2"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    props.handleButtonClick(
                      "custom",
                      customStartDate,
                      customEndDate,
                    );
                    setOpen('');
                  }}
                  className="rounded-md bg-tqsYellow px-4 py-2 text-tqsBlack"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
